import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import useWindowSize from "../Hooks/windowSize";

const LeftSection = ({
  applyAbled,
  reset,
  handleEnglishTextAreaValue,
  handleArabicTextAreaValue,
  englishTextValue,
  arabicTextValue,
}) => {
  // const [englishTextValue, setEnglishTextValue] = useState("");
  // const [arabicTextValue, setArabicTextValue] = useState("");
  const [width, height] = useWindowSize();

  // useEffect(() => {
  //   handleTextAreaValue(englishTextValue, arabicTextValue);
  // }, [englishTextValue, arabicTextValue]);

  return (
    <div
      className="left-section"
      style={{ opacity: applyAbled ? "0.3" : null }}
    >
      <Row>
        <Col span={12}>
          <div className="english-heading">text here</div>
        </Col>
        <Col span={12}>
          <div className="arabic-heading">النص هنا</div>
        </Col>
      </Row>
      <Row>
        <Col span={12} style={{ height: "100%", color: "black" }}>
          <textarea
            value={englishTextValue}
            onChange={(e) => {
              handleEnglishTextAreaValue(e.target.value);
              // setEnglishTextValue(e.target.value);
            }}
            className="english-textarea"
            placeholder="insert text here (minimum 1000 words)..."
            style={{
              marginLeft: "5%",
              height: height - 382,
            }}
          />
        </Col>
        <Col span={12}>
          <textarea
            value={arabicTextValue}
            onChange={(e) => {
              const formattedText = e.target.value;
              handleArabicTextAreaValue(formattedText);
            }}
            className="english-textarea"
            placeholder="أدخل النص هنا (الف كلمة على الأقل)..."
            style={{
              direction: "rtl",
              height: height - 382,
            }}
            lang="ar"
          />
        </Col>
      </Row>
    </div>
  );
};

export default LeftSection;
